import { useEffect } from 'react';
import Cookies from 'universal-cookie';

/**
 * this is a bandaid solution to solve for marketing campaigns formatting
 * query strings incorrectly.
 */
const correctDuplicateQuestionMark = (url: string) => {
	const urlParts = url.split('?');
	if (urlParts.length <= 2) {
		return url;
	}

	let queryString = urlParts.slice(1).join('?');
	queryString = queryString.replace(/\?/g, '&');
	return `?${queryString}`;
};

const marketingSourceUrlParse = async () => {
	const queryString = window.location.search;
	const marketingParamsExist = queryString.includes('trans_id');

	if (marketingParamsExist) {
		const cookies = new Cookies();
		const ThirtyDaysFromNow = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);

		cookies.set('marketing_source', correctDuplicateQuestionMark(queryString), { expires: ThirtyDaysFromNow });
	}
};

export function useMarketingSourceUrlParse() {
	useEffect(() => {
		marketingSourceUrlParse();
	}, []);
}
